<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions>
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn icon
                               color="blue"
                               @click="onPressReload"
                               :loading="reloading"
                        ><v-icon>mdi-reload</v-icon></v-btn>
                    </v-card-actions>
                    <v-card-actions>
                        <i-view style="width: 100%"></i-view>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import IView from "@/modules/minbox/views/i-view";
import InboxStore from "@/modules/minbox/database/InboxStore";
import {InboxStoreUtils} from "@/modules/minbox/database/InboxStoreUtils";

export default {
    components: {IView},
    data: () => ({
        loading: true,
        message: "",
        tab: null,
        reloading:false,
    }),
    methods: {
        onPressReload(){
            this.reloading = true
            InboxStoreUtils.fetchInboxes().then(()=>{
                this.reloading = false
            })
        }
    },
    beforeMount() {
        this.loading = false
        this.$store.registerModule("inbox-store", InboxStore);
        this.$store.dispatch("inbox-store/init").then(() => {
            console.log("Loaded successfully. inbox-store");
        }).catch(() => {
            this.message = "Load failed!";
        }).finally(() => {
            this.loading = false;
        });
    },
    destroyed() {
        this.$store.unregisterModule("inbox-store");
        console.log("destroy root view minbox");
    }
}
</script>

<style scoped>
</style>